<template>
    <BaseContainer class="dnnCloud-credits-box" :loading="listLoading" :isHasPageFt="!listLoading">
        <template v-slot:hd>
            <!--工具条-->
            <el-col :span="24" class="toolbar">
              <el-form :inline="true" :model="souchs" @submit.native.prevent>
                <!-- <el-select v-model="value" placeholder="请选择" @change="changeSouch"  style="width:120px;margin-top:2px">
                  <el-option v-for="item in optionsSouch" :key="item.value"  
                    :label="item.label" :value="item.value">
                  </el-option>
                </el-select> -->

                <el-form-item>
                    <el-input  v-model="searchText"  placeholder="账号 / 姓名 /企业" style="width:200px;"  @keyup.enter.native="getUser(1)"></el-input>
                </el-form-item>

                <el-form-item>
                   <el-select  v-model="souchs.softtype" placeholder="软件类型" style="width:200px;" clearable >
                    <el-option v-for="item in softtypes" :key="item.value" 
                      :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item>
                  <!-- 日期范围 -->
                  <el-date-picker  v-model="dateRange" @change="handerChangePicker" style="position: relative; top: 2px; width: 260px"
                    type="daterange"  value-format="yyyy-MM-dd" range-separator="~" start-placeholder="开始日期" end-placeholder="结束日期" ></el-date-picker>
                </el-form-item>

                <!-- <el-form-item>
                  <el-input v-show="disSouch" v-model="proName" style="width:200px;"  @keyup.enter.native="getUser(1)"></el-input>
                  <el-select v-show="disinvit" v-model="souchs.invitValue" placeholder="请选择" style="width:200px;" clearable >
                    <el-option v-for="item in inviValues" :key="item.value" 
                      :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                  
                  <el-select v-show="disSofttype" v-model="souchs.softtype" placeholder="请选择" style="width:200px;" clearable >
                    <el-option v-for="item in softtypes" :key="item.value" 
                      :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>

                  <el-date-picker  v-model="dateRange" @change="handerChangePicker" style="position: relative; top: 2px; width: 260px"
                    type="daterange"  value-format="yyyy-MM-dd" range-separator="~" start-placeholder="开始日期" end-placeholder="结束日期" ></el-date-picker>
                
                </el-form-item> -->

                <el-form-item>
                  <el-button type="primary" size="medium" v-on:click="getUser(1)">查询</el-button>
                  <el-button type="primary" size="medium" ><a :href="downHrefExcel" style="color: #fff;">导出数据</a></el-button>
                </el-form-item>
              </el-form>

               <!--<el-tag :key="tag" v-for="tag in dynamicTags" closable 
                :disable-transitions="false" @close="handleClose(tag)"> 
                  {{tag}} 
              </el-tag>
              <el-button v-if="dynamicTags!=''" class="button-new-tag" size="small" @click="delTags">清除标签</el-button> -->
            </el-col>
        </template>

        <template v-slot:main>
            <!--列表-->
            <el-table  :data="users" highlight-current-row   style="width: 100%;" :height="maxTbHeight"
              :header-cell-style="getRowClass" @sort-change="handleSortChange">
              <el-table-column type="index" :index="indexMethod" label="序号" width="80">
                <template slot-scope="scope">
                    <span>{{(pageNumber - 1) * pageSize + scope.$index + 1}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="phone" label="账号" min-width="140" sortable="custom" show-overflow-tooltip>
              </el-table-column>
              <el-table-column prop="name" label="姓名" min-width="100" sortable="custom" show-overflow-tooltip>
              </el-table-column>
              <el-table-column prop="sumpoint" label="可用积分" min-width="140" sortable="custom" show-overflow-tooltip>
              </el-table-column>
              <el-table-column prop="registertime" label="注册日期" min-width="180" sortable="custom">
              </el-table-column>
              <el-table-column prop="softtype" label="软件类型"  min-width="120" sortable="custom" show-overflow-tooltip>
              </el-table-column>
              <el-table-column prop="company" label="企业" min-width="180" sortable="custom" show-overflow-tooltip>
              </el-table-column>
            </el-table>
        </template>

        <template v-slot:ft>
            <!--分页工具条-->
            <el-col :span="24" class="toolbar">
              <el-pagination 
                layout="sizes, prev, pager, next"
                :page-sizes="[10, 20, 30, 50,100]"
                :current-page="pageNumber" 
                @current-change="handleCurrentChange" 
                @size-change="handleSizeChange"
                :page-size="pageSize" 
                :total="total" 
                style="float:right;">
              </el-pagination>
            </el-col>
        </template>

    </BaseContainer>
</template>
<script>
import { API__code, API_User ,API_Models, API_Admin, API_Integral} from '../../api/index.js'
import $ from 'jquery'
import BaseContainer from '@/components/BaseContainer'
import fitTableHeight from '@/mixins/fitTableHeight.js'
export default {
  mixins: [fitTableHeight],
  data(){
    return {
      downHrefExcel:'',//用户导出
      downHref:'',
      disSouch:true,
      disinvit:false,  
      disSofttype:false,
      disTime1:false,
      disTime2:false,
      proName:"",
      dynamicTags: [],
      optionsSouch: [
        {value: '账号',label: '账号'}, 
        {value: '姓名',label: '姓名'},
        {value: '企业',label: '企业'},
        {value: '软件类型',label: '软件类型'},
        // {value: '邀请状态',label: '邀请状态'},
        // {value: '开始日期',label: '开始日期'},
        // {value: '结束日期',label: '结束日期'},
      ],
      value: '',
      inviValues:[],
      softtypes:[],
      yhlx:[],
      zhlx:[],
      cities:[],
      citiesd: [],
      userModule:[],
      editForm:{},
      editLoading:false,
      options: [{
        value: '1',
        label: '一个月'
      }, {
        value: '2',
        label: '二个月'
      }, {
        value: '3',
        label: '三个月'
      }, {
        value: '4',
        label: '四个月'
      }, {
        value: '5',
        label: '五个月'
      }, {
        value: '6',
        label: '六个月'
      }],
      id:'',
      token:'',
      checkCode:'',
      listLoading:false,
      souchs:{
        phone:'',
        name:'',
        company:'',
        // 开始 & 结束日期
        fromtime: '',
        totime: '',
      },
      orderStr:'',
      orderType:'',
      pageNumber:1,
      pageSize: 20,
      total:0,
      users:[],
      companyList:[],
    
      // 日期范围
      dateRange: '',
      searchText:'',
    }
  },

  components: {
    BaseContainer
  },

  methods:{
    handerChangePicker(dateArr) {
      console.log("dateArr==", dateArr)
      if(dateArr) {
          // 开始 & 结束日期
        this.souchs.fromtime = dateArr[0]
        this.souchs.totime =   dateArr[1];
        return
      }
      // 删除日期
      this.souchs.fromtime = '';
      this.souchs.totime = '';

    },
    handleClose(tag) {
      if(tag == "账号"){
        this.souchs.phone = '';
        if(this.value == "账号"){
          this.proName = '';
        }
      }
      if(tag == "姓名"){
        this.souchs.name = '';
        if(this.value == "姓名"){
          this.proName = '';
        }
      }
      if(tag == "企业"){
        this.souchs.company = '';
        if(this.value == "企业"){
          this.proName = '';
        }
      }
      if(tag == "软件类型"){
        this.souchs.softtype = "";
      }
      if(tag == "邀请状态"){
        this.souchs.invitValue = "";
      }
      if(tag == "开始日期"){
        this.souchs.fromtime ="";
      }
      if(tag == "结束日期"){
        this.souchs.totime ="";
      }
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
    },

    delTags:function(){
      this.souchs = {};
      this.proName = '';
      this.value = '';
      this.dynamicTags = [];
      this.pageNumber = 1;
      this.getUser();
    },

    changeSouch:function(val){
      this.disSouch=false;
      this.disinvit=false;  
      this.disSofttype=false;
      this.disTime1=false;
      this.disTime2=false;
      if(val == "账号"){
        this.proName = this.souchs.phone;
        this.disSouch = true;
      }else if(val == "姓名"){
        this.proName = this.souchs.name;
        this.disSouch = true;
      }else if(val == "企业"){
        this.proName = this.souchs.company;
        this.disSouch = true;
      }else if(val == "软件类型"){
        this.disSofttype = true;
      }else if(val == "邀请状态"){
        this.disinvit = true;  
      }else if(val == "开始日期"){
        this.disTime1 = true;
      }else if(val == "结束日期"){
        this.disTime2 = true;
      }
    },

    handleSortChange:function(val){
      if(val){
        if(val.prop == "phone"){
          this.orderStr = "phoneOrder";
        }else if(val.prop == "name"){
          this.orderStr = "nameOrder";
        }else if(val.prop == "point"){
          this.orderStr = "pointOrder";
        }else if(val.prop == "userName"){
          this.orderStr = "usertypeOrder";
        }else if(val.prop == "softtype"){
          this.orderStr = "codeOrder";
        }else if(val.prop == "registertime"){
          this.orderStr = "registertimeOrder";
        }else if(val.prop == "company"){
          this.orderStr = "companyOrder";
        }
        if(val.order == "descending"){
          this.orderType = "desc";
        }else{
          this.orderType = "asc";
        }
      }
      this.getUser();
    },
  

    indexMethod(index) {
      return (index+1)+(this.pageNumber-1)*pageSize;
    },

    getRowClass({ row, column, rowIndex, columnIndex }) {
        return rowIndex == 0? "background:#F5F7FA": ''
    },

    handleCurrentChange(val) {
      this.pageNumber = val;
      this.getUser();
    },

    handleSizeChange(val) {
			this.pageSize = val;
			this.getUser();
		},

    getUser:function(val){
      if(this.value == "账号"){
        this.souchs.phone = this.proName;
      }
      if(this.value == "企业"){
        this.souchs.company = this.proName;
      }
      if(this.value == "姓名"){
        this.souchs.name = this.proName;
      }

      var flag = true;
      if(val == 1){
        this.pageNumber = 1;
        if(this.value){
          if(this.dynamicTags.length > 0){
            for(var i=0;i<this.dynamicTags.length;i++){
              if(this.value == this.dynamicTags[i]){
                flag = false;
              }
            }
          }
          if(flag){
            this.dynamicTags.push(this.value);
          }
        }
      }
      let param = {
        token:this.token,
        checkCode:this.checkCode,
        pageNumber:this.pageNumber,
        pageSize:this.pageSize,
        listType:'page',
        userType:'',
        // searchStr:this.souchs.modelName,
        username:this.souchs.name,
        phone:this.souchs.phone,
        company:this.souchs.company,
        registertimefrom:this.souchs.fromtime,
        registertimeto:this.souchs.totime,
        softtype:this.souchs.softtype,
        invitestatus:this.souchs.invitValue,
        
        orderType: this.orderType,
        orderStr: this.orderStr,
        searchText: this.searchText,
      }

      this.downHrefExcel = API_Integral.exportCreditsExcel()+"?token="+this.token+ 
      "&checkCode="+this.checkCode+
      "&registertimefrom="+(this.souchs.fromtime || '')+
      "&registertimeto="+(this.souchs.totime || '')+
      "&softtype="+(this.souchs.softtype || '')+
      "&invitestatus="+(this.souchs.invitestatus|| '')+
      "&phone="+(this.souchs.phone|| '')+
      "&company="+(this.souchs.company|| '')+
      "&username="+(this.souchs.name|| '')+"";

      this.listLoading = true
      API_Integral.getcreditsPage(param)
      .then((res) =>{
        if(res.data.code == API__code.SUCCESS){
          if(res.data.data){
            for(var i=0;i<res.data.data.list.length;i++){
              res.data.data.list[i].registertimeyuan = res.data.data.list[i].registertime;
              if(res.data.data.list[i].registertime){
                res.data.data.list[i].registertime = res.data.data.list[i].registertime.substring(0,10);
              }
            }
            this.total = res.data.data.totalRow;
            this.users = res.data.data.list;
            this.listLoading = false
            // for(var i=0;i<this.users.length;i++){
              // for(var k=0;k<this.zhlx.length;k++){
              //   if(this.users[i].usertype == this.zhlx[k].value){
              //     this.users[i].userName = this.zhlx[k].text;
              //   }
              // }
              // this.users[i].status='';
              // if(this.users[i].module){
              //   if(JSON.parse(this.users[i].module).status == true ){
              //     var time  = (JSON.parse(this.users[i].module).time).replace(/-/g,"/");//一般得到的时间的格式都是：yyyy-MM-dd hh24:mi:ss，所以我就用了这个做例子，是/的格式，就不用replace了。  
              //     time = new Date(time);
              //     var now = new Date();  
              //     if(time.getFullYear() < now.getFullYear()){  
              //         this.users[i].status = '过期';
              //     }else{
              //       if(time.getFullYear() == now.getFullYear()){
              //         if(time.getMonth() < now.getMonth()){  
              //           this.users[i].status = '过期';    
              //         }else{
              //           if(time.getMonth() == now.getMonth()){
              //             if(myDate.getDate() < now.getDate()){  
              //                 this.users[i].status = '过期';
              //             }
              //           }
              //         }  
              //       }
              //     }
              //     if(!this.users[i].status){
              //       this.users[i].status = '正在试用';
              //     }
              //   }
              //   if(JSON.parse(this.users[i].module).status == false ){
              //     this.users[i].status = '申请试用';
              //   }
              //   this.users[i].type ='试用';
              // }
            // }
          }
        }else{
          this.$message.error(res.data.message);
          if(res.data.code == 403){
            this.$router.push({path: 'loginAdmin'});
          }
        }
      }).catch(err =>{
        this.$message.error('数据丢失，试试重新登陆！');
      });
    },

    getModels:function(){
      let param = {
        token:this.token,
        checkCode:this.checkCode,
      };
      API_Models.getAdminModule(param)
      .then((res) =>{
        if(res.data.code == API__code.SUCCESS){
          this.models = res.data.data;
          this.cities=[];
          this.citiesd = [];
          for(var i =0;i<res.data.data.length;i++){
            this.cities.push(res.data.data[i].modulename);
            var jsones = {"modulename":res.data.data[i].modulename,"id":res.data.data[i].id};
            this.citiesd.push(jsones);
          }
        }else{
          this.$message.error(res.data.message);
          if(res.data.code == 403){
            this.$router.push({path: 'loginAdmin'});
          }
        }
      }).catch(err =>{
        this.$message.error('数据丢失，试试重新登陆！');
      });
    },

    //读取cookie
    getCookie: function() {
        if (document.cookie.length > 0) {
            var arr = document.cookie.split('; '); //这里显示的格式需要切割一下自己可输出看下
            for (var i = 0; i < arr.length; i++) {
                var arr2 = arr[i].split('='); //再次切割
                //判断查找相对应的值
                if (arr2[0] == 'dnnyptadmin_token') {
                    this.token = arr2[1]; //保存到保存数据的地方
                } else if (arr2[0] == 'dnnyptadmin_checkCode') {
                    this.checkCode = arr2[1];
                } else if (arr2[0] == 'dnnyptadmin_id') {
                    this.id = arr2[1];
                }
            }
        }
    },

    getCode1:function(){
      let _this = this;
      let param = {
        token:this.token,
        checkCode:this.checkCode,
      }
      API_Admin.UserList(param)
      .then((res) =>{
        if(res.data.code == API__code.SUCCESS){
          // this.yhlx = res.data.data;
          _this.yhlx=[];
          _this.softtypes = [];
          for(var i=0;i<res.data.data.length;i++){
            var jsons = {"value":res.data.data[i].code,"text":res.data.data[i].name}
            _this.yhlx.push(jsons);
            var json = {'value': res.data.data[i].code,'label': res.data.data[i].name}
            _this.softtypes.push(json);
          }
        }else{
          this.$message.error(res.data.message);
          if(res.data.code == 403){
            this.$router.push({path: 'loginAdmin'});
          }
        }
      });

      API_Admin.tbCompanyList(param)
      .then((res) =>{
        if(res.data.code == API__code.SUCCESS){
          this.companyList = res.data.data;
          //_this.yhlx=[];
        }
      });
    },

    getCode2:function(){
      let _this = this;
      let param = {
        token:this.token,
        checkCode:this.checkCode,
      }
      API_Admin.AccList(param)
      .then((res) =>{
        if(res.data.code == API__code.SUCCESS){
          _this.zhlx=[];
          for(var i=0;i<res.data.data.length;i++){
            var jsons = {"value":res.data.data[i].code,"text":res.data.data[i].name}
            _this.zhlx.push(jsons);
          }
        }else{
          this.$message.error(res.data.message);
          if(res.data.code == 403){
            this.$router.push({path: 'loginAdmin'});
          }
        }
      });
    },
   
    getCode:function(){
      let _this = this;
      let param ={
        token:this.token,
        checkCode:this.checkCode,
        type:7,
      }
      API_User.getCode(param)
      .then((res) =>{
        if(res.data.code == API__code.SUCCESS){
          _this.inviValues = [];
          for(var i=0;i<res.data.data.length;i++){
            var jsons = {"value":res.data.data[i].code,"label":res.data.data[i].name}
            _this.inviValues.push(jsons);
          }
        }else{
          this.$message.error(res.data.message);
          if(res.data.code == 403){
            this.$router.push({path: 'loginAdmin'});
          }
        }
      });
    },
  },

  created(){

    this.getCookie();
    this.getCode1();
    this.getCode2();

    if(this.$route.query.type == 1){
      this.dynamicTags = JSON.parse(this.$route.query.dynamicTags);
      this.souchs = JSON.parse(this.$route.query.souchs);
      this.pageNumber = JSON.parse(this.$route.query.pageNumber);
    }
    this.getUser();
    this.getModels();
    this.getCode();

    this.downHref = API_Admin.userExcelTemplate()+"?token="+this.token+"&checkCode="+this.checkCode;
    
  },
 
}
</script>
<style lang="scss">
.dnnCloud-credits-box {
  .base-container-bd {
    .content-hd {
      .el-form-item {
        margin-bottom: 0;
      }
    }
  }
}

</style>
<style scoped>
.el-select {
    display: inline-block;
    position: relative;
    width: 115px;
}
.el-tag + .el-tag {
    margin-left: 10px;
}

a{
    text-decoration: none;
    color: #2196F3;
  }
</style>


// WEBPACK FOOTER //
// query.vue?68827a02